var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.8333 28V25.3333C29.8333 22.8482 28.1336 20.7601 25.8333 20.168M21.1666 4.38768C23.1212 5.17886 24.5 7.09508 24.5 9.33333C24.5 11.5716 23.1212 13.4878 21.1666 14.279M23.1666 28C23.1666 25.515 23.1666 24.2725 22.7607 23.2924C22.2193 21.9855 21.1811 20.9473 19.8743 20.406C18.8942 20 17.6516 20 15.1666 20H11.1666C8.6816 20 7.43909 20 6.45898 20.406C5.15216 20.9473 4.1139 21.9855 3.5726 23.2924C3.16663 24.2725 3.16663 25.515 3.16663 28M18.5 9.33333C18.5 12.2789 16.1121 14.6667 13.1666 14.6667C10.2211 14.6667 7.83329 12.2789 7.83329 9.33333C7.83329 6.38781 10.2211 4 13.1666 4C16.1121 4 18.5 6.38781 18.5 9.33333Z",
    stroke: "#D53716",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.c2394a37654a46aaf8a16594b57ae07e.svg";
export { ForwardRef as ReactComponent };